<template functional>
	<div class="page-title-wrapper page-title" :class="data.staticClass" :style="data.staticStyle">
		<h4 class="page-title-wrapper__title">
			<span v-if="props.title">{{ props.title }}</span>
			<slot name="title"></slot>
		</h4>
		<div class="page-title-wrapper__body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'pageTitle',
	props: ['title'],
};
</script>

<style lang="scss">
.page-title-wrapper {
	position: relative;
	border-radius: 4px;
	background-color: white;
	margin-bottom: 20px;
	&__title {
		padding: 24px 20px;
		height: 20px;
		font-size: 14px;
		color: #040b28;
		line-height: 20px;
		display: flex;
		align-items: center;
	}
	&__body {
		padding: 0 20px 20px;
		background-color: white;
	}
}
</style>
